import React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from 'reactstrap';
import { faCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-light-svg-icons/faDownload';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../../common/views/SMLButton/SMLButton';
import { useSMLRouter } from '../../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../../routing/sml/SMLRoutes';
import { downloadMediaUrl } from '../../inlineMediaUrl';
import { SerializedReel } from '../../types';
import { studioThemeMessages } from '../studioThemeMessages';
import { reelReviewMessages } from './reelReviewMessages';
import { WatermarkDownloadLink } from '../../../watermarkUpsell/choice/WatermarkDownloadLink';
import { choiceFileOfReel } from '../../../watermarkUpsell/files/choiceFiles';
import { WatermarkCallout } from '../../../watermarkUpsell/files/WatermarkCallout';
import { fileHasWatermark } from '../../../watermarkUpsell/files/watermarkedFile';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
import { trackAssetDownloaded } from '../../assetEvents';
/* eslint-enable css-modules/no-unused-class */

/**
 * An approved reel (design c2): no Approve or Reject. "Open the Calendar" shows its draft posts;
 * "Download" saves the video. A reel of Free or the trial has the watermark in the video: the
 * callout says so, and Download opens the choice first (design: trial-upsell a2, a3).
 */
const ReelApprovedNoticeComponent: React.FC<{ reel: SerializedReel }> = ({ reel }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  const hasWatermark = fileHasWatermark(reel);

  return (
    <>
      <Alert color="success" className="mb-0">
        <strong>{intl.formatMessage(reelReviewMessages.approvedTitle)}</strong>
        <br />
        {intl.formatMessage(reelReviewMessages.approvedBody)}
      </Alert>
      <div className={styles.actions}>
        <SMLButton color="primary" omitCap leftIcon={faCalendar} onClick={() => router.push(SMLRoutes.promoteCalendar)}>
          {intl.formatMessage(reelReviewMessages.openCalendar)}
        </SMLButton>
        {reel.video !== null && (
          <WatermarkDownloadLink
            className="btn btn-outline-primary"
            href={downloadMediaUrl(reel.video.url)}
            hasWatermark={hasWatermark}
            file={choiceFileOfReel(reel, intl.formatMessage(studioThemeMessages.aiReel.name), null)}
            onDownload={() => trackAssetDownloaded('aiReel', 'viewer')}
          >
            <FontAwesomeIcon icon={faDownload} className="me-2" />
            {intl.formatMessage(reelReviewMessages.download)}
          </WatermarkDownloadLink>
        )}
      </div>
      {hasWatermark && <WatermarkCallout variant="file" surface="viewer" preview={reel.preview === true} />}
    </>
  );
};

export const ReelApprovedNotice = TypedMemo(ReelApprovedNoticeComponent);
